import ListStockTakes from "../../../../components/@documents/stock_takes/ListStockTakes";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function StockTakesPage() {

    return (
        <ListStockTakes 
            routeType={routeTypes.retail}
        />
    )
}